import React from 'react';
import { motion } from 'framer-motion';
export function FoolCardImage() {
  return <section className="py-16 px-4 bg-[#0C0F17]" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/uvu5pkoXzczkpiS8vNmiDu/ChatGPT_Image_Dec_4,_2025,_12_03_33_AM_(1).png" alt="The Fool Tarot Card" className="w-full rounded-2xl shadow-2xl" style={{
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.6)'
        }} data-id="element-118" />

          {/* Subtle vignette overlay */}
          <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
          background: 'radial-gradient(circle at center, transparent 40%, rgba(12, 15, 23, 0.4) 100%)'
        }} data-id="element-119" />
        </motion.div>
      </div>
    </section>;
}